// Fashion Brands - Ranked by Market Cap/Value
// Difficulty: EASY - Most people know these brands

export const fashionBrandsData = [
  { id: 1, name: "Louis Vuitton", rank: 1, image: "/images/fashionBrands/louis_vuitton.png" },
  { id: 2, name: "Hermès", rank: 2, image: "/images/fashionBrands/hermes.png" },
  { id: 3, name: "Nike", rank: 3, image: "/images/fashionBrands/nike.png" },
  { id: 4, name: "Dior", rank: 4, image: "/images/fashionBrands/dior.png" },
  { id: 5, name: "Chanel", rank: 5, image: "/images/fashionBrands/chanel.png" },
  { id: 6, name: "Gucci", rank: 6, image: "/images/fashionBrands/gucci.png" },
  { id: 7, name: "Adidas", rank: 7, image: "/images/fashionBrands/adidas.png" },
  { id: 8, name: "Lululemon", rank: 8, image: "/images/fashionBrands/lululemon.png" },
  { id: 9, name: "Prada", rank: 9, image: "/images/fashionBrands/prada.png" },
  { id: 10, name: "Burberry", rank: 10, image: "/images/fashionBrands/burberry.png" },
  { id: 11, name: "Ralph Lauren", rank: 11, image: "/images/fashionBrands/ralph_lauren.png" },
  { id: 12, name: "Hugo Boss", rank: 12, image: "/images/fashionBrands/hugo_boss.png" },
  { id: 13, name: "Calvin Klein", rank: 13, image: "/images/fashionBrands/calvin_klein.png" },
  { id: 14, name: "Coach", rank: 14, image: "/images/fashionBrands/coach.png" },
  { id: 15, name: "Michael Kors", rank: 15, image: "/images/fashionBrands/michael_kors.png" },
  { id: 16, name: "Tommy Hilfiger", rank: 16, image: "/images/fashionBrands/tommy_hilfiger.png" },
  { id: 17, name: "Zara", rank: 17, image: "/images/fashionBrands/zara.png" },
  { id: 18, name: "H&M", rank: 18, image: "/images/fashionBrands/hm.png" },
  { id: 19, name: "Uniqlo", rank: 19, image: "/images/fashionBrands/uniqlo.png" },
  { id: 20, name: "Gap", rank: 20, image: "/images/fashionBrands/gap.png" },
  { id: 21, name: "Levi's", rank: 21, image: "/images/fashionBrands/levis.png" },
  { id: 22, name: "Under Armour", rank: 22, image: "/images/fashionBrands/under_armour.png" },
  { id: 23, name: "Puma", rank: 23, image: "/images/fashionBrands/puma.png" },
  { id: 24, name: "New Balance", rank: 24, image: "/images/fashionBrands/new_balance.png" },
  { id: 25, name: "Versace", rank: 25, image: "/images/fashionBrands/versace.png" },
];
